{{#with accessorHandle}}
function automatic void add_{{ identifier }}_to_config_db(string {{ ../instName }});
  {{ type }} {{ identifier }} = new();
  uvm_config_db#({{ ../abstractAccessor.type }})::set(null, {{ ../instName }}, "{{ ../abstractAccessor.configDbKey }}", {{ identifier }});
endfunction
{{/with}}
